var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"tw-mt-2",attrs:{"justify":"center"}},[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.goToUrl}},[_c('i',{staticClass:"fas fa-edit fa-fw tw-mr-2"}),_vm._v("\n        "+_vm._s(_vm.$t('show.edit-pigeon'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }